import {createStore} from 'vuex'

import AuthModule from "@/store/module/AuthModule";
import BodyModule from "@/store/module/BodyModule";
import BreadcrumbsModule from "@/store/module/BreadcrumbsModule";
import ConfigModule from "@/store/module/ConfigModule";
import Library from "@/store/library/";
import LibraryDirectory from "@/store/library/directory/";
import LibraryDirectoryTree from "@/store/library/directory/tree.js";
import LibraryVideo from "@/store/library/video/";
import LibraryVideoGroup from "@/store/library/video/group";
import LibraryTrash from "@/store/library/trash";
import DeveloperCustomerManagementCompany from "@/store/developer/customer-management/company";
import DeveloperCustomerManagementCustomer from "@/store/developer/customer-management/customer";
import DeveloperCustomerManagementGroup from "@/store/developer/customer-management/group";
import DeveloperCdnServer from "@/store/developer/cdn-management/cdn-server";
import DeveloperCdnMigrate from "@/store/developer/cdn-management/cdn-migrate";
import DeveloperVideoDownloader from "@/store/developer/video-management/downloader";
import DeveloperVideoConverter from "@/store/developer/video-management/converter";
import DeveloperVideoMigrator from "@/store/developer/video-management/migrate";
import StoreCart from "@/store/store/cart";


//Default
export const store = createStore({
    modules: {
        library: Object.assign(Library, {
            modules: {
                directory: Object.assign(LibraryDirectory, {
                    modules: {
                        tree: LibraryDirectoryTree,
                    }
                }),
                video: Object.assign(LibraryVideo, {
                    modules: {
                        group: LibraryVideoGroup,
                    }
                }),
                trash: LibraryTrash,
            }
        }),
        store: {
            namespaced: true,
            modules: {
                cart: StoreCart,
            }
        },
        developer: {
            namespaced: true,
            modules: {
                customerManagement: {
                    namespaced: true,
                    modules: {
                        company: DeveloperCustomerManagementCompany,
                        customer: DeveloperCustomerManagementCustomer,
                        group: DeveloperCustomerManagementGroup,
                    }
                },
                cdnManagement: {
                    namespaced: true,
                    modules: {
                        cdnServer: DeveloperCdnServer,
                        cdnMigrate: DeveloperCdnMigrate,
                    }
                },
                videoManagement: {
                    namespaced: true,
                    modules: {
                        downloader: DeveloperVideoDownloader,
                        converter: DeveloperVideoConverter,
                        migrator: DeveloperVideoMigrator,
                    }
                },
            }
        },
        AuthModule,
        BodyModule,
        BreadcrumbsModule,
        ConfigModule
    }
});


export default store;